import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CustomerState {
  accessToken: string;
  refreshToken: string;
}

const initialState: CustomerState = {
  accessToken: "",
  refreshToken: "",
};

const CustomerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    loginCustomer(
      state,
      action: PayloadAction<{ accessToken: string; refreshToken: string }>
    ) {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
    },
    logoutCustomer(state) {
      state.accessToken = "";
      state.refreshToken = "";
    },
  },
});

export const { loginCustomer, logoutCustomer } = CustomerSlice.actions;
export default CustomerSlice.reducer;
